/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SubscriptionChangePlanPreviewRequest } from '../models/SubscriptionChangePlanPreviewRequest';
import type { SubscriptionChangePlanPreviewView } from '../models/SubscriptionChangePlanPreviewView';
import type { SubscriptionChangePlanRequest } from '../models/SubscriptionChangePlanRequest';
import type { SubscriptionCheckView } from '../models/SubscriptionCheckView';
import type { SubscriptionView } from '../models/SubscriptionView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SubscriptionService {
    /**
     * Check subscription by plugin name
     * Check if current user has active subscription for specified plugin
     * @param pluginName Plugin name (e.g. mobile_default, jtl_shop, etc.)
     * @returns SubscriptionCheckView Subscription check result
     * @throws ApiError
     */
    public static getAppSubscriptionCheck(
        pluginName: string,
    ): CancelablePromise<SubscriptionCheckView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/subscriptions/check/{pluginName}',
            path: {
                'pluginName': pluginName,
            },
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Get all subscriptions
     * Get all subscriptions for current user
     * @returns SubscriptionView List of subscriptions
     * @throws ApiError
     */
    public static getAppSubscriptionList(): CancelablePromise<Array<SubscriptionView>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/subscriptions',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Activate free subscription
     * Activate free/trial subscription for specified plugin
     * @param pluginName Plugin name (e.g. mobile, freshdesk)
     * @returns SubscriptionView Free subscription activated
     * @throws ApiError
     */
    public static postAppSubscriptionActivateFree(
        pluginName: string,
    ): CancelablePromise<SubscriptionView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/subscriptions/activate-free/{pluginName}',
            path: {
                'pluginName': pluginName,
            },
            errors: {
                400: `Error (already has subscription or no free product)`,
                404: `Free product not found for this plugin`,
            },
        });
    }
    /**
     * Cancel subscription
     * Cancel an active subscription. For Stripe subscriptions, it will also cancel the subscription in Stripe.
     * @param subscriptionId Subscription ID
     * @returns SubscriptionView Subscription cancelled successfully
     * @throws ApiError
     */
    public static postAppSubscriptionCancel(
        subscriptionId: string,
    ): CancelablePromise<SubscriptionView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/subscriptions/{subscriptionId}/cancel',
            path: {
                'subscriptionId': subscriptionId,
            },
            errors: {
                400: `Error (subscription not active or already cancelled)`,
                404: `Subscription not found`,
            },
        });
    }
    /**
     * Preview a plan change without committing it
     * Returns the auto-detected direction (upgrade/sidegrade/downgrade), an approximate proration charge for upgrade, and the before/after recurring prices so the frontend modal can show "you will be charged ~X — was Y, will be Z". Does NOT call any side-effecting Stripe API; proration math is local and approximate.
     * @param subscriptionId Source subscription ID
     * @param requestBody
     * @returns SubscriptionChangePlanPreviewView Preview computed
     * @throws ApiError
     */
    public static postAppSubscriptionChangePlanPreview(
        subscriptionId: string,
        requestBody: SubscriptionChangePlanPreviewRequest,
    ): CancelablePromise<SubscriptionChangePlanPreviewView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/subscriptions/{subscriptionId}/change-plan/preview',
            path: {
                'subscriptionId': subscriptionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                403: `Subuser cannot preview plan change`,
                404: `Subscription or target product not found`,
            },
        });
    }
    /**
     * Change subscription plan (upgrade or scheduled downgrade)
     * Server-side autodetects direction by comparing new product.priceNetto to current.priceNetto. Upgrade (or sidegrade) updates the existing Stripe subscription with proration and immediate invoicing. Downgrade schedules a new Stripe subscription to start at the current period end — no refunds. Returns 409 with `errorCode=pending_payment` if a previous Stripe invoice is still open and unpaid.
     * @param subscriptionId Source subscription ID
     * @param requestBody
     * @returns any Plan change accepted (upgrade billed immediately; downgrade scheduled)
     * @throws ApiError
     */
    public static postAppSubscriptionChangePlan(
        subscriptionId: string,
        requestBody: SubscriptionChangePlanRequest,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/subscriptions/{subscriptionId}/change-plan',
            path: {
                'subscriptionId': subscriptionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                403: `Subuser cannot change plan`,
                404: `Subscription or target product not found`,
                409: `Previous Stripe invoice still open; complete or void it before changing plan`,
                503: `Could not verify Stripe state (transient); retry later`,
            },
        });
    }
    /**
     * Cancel a pending scheduled downgrade
     * Releases the Stripe schedule, marks the pre-created Subscription B as cancelled, and removes cancel_at_period_end from the active subscription A.
     * @param subscriptionId Active subscription A whose scheduled change to cancel
     * @returns SubscriptionView Scheduled change cancelled
     * @throws ApiError
     */
    public static deleteAppSubscriptionCancelScheduledChange(
        subscriptionId: string,
    ): CancelablePromise<SubscriptionView> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/api/subscriptions/{subscriptionId}/scheduled-change',
            path: {
                'subscriptionId': subscriptionId,
            },
            errors: {
                400: `No pending scheduled change`,
                403: `Subuser cannot cancel scheduled change`,
                404: `Subscription not found`,
            },
        });
    }
}
